<template>
  <q-dialog v-model="shown">
    <q-card
      style="min-width: 70%; display: flex; flex-direction: column;"
      :style="{ 'max-height': $q.screen.gt.sm ? '90vh' : '100vh' }"
      :loading="loading"
    >
      <q-inner-loading
        style="z-index: 1000"
        :showing="loading"
      >
        <q-spinner size="xl" />
        <div v-if="linkingModelTotal !== 0 && !$_.isEmpty(linkingModelName)">
          Linking {{ linkingModelName }} ({{ linkingModelIndex }}/{{ linkingModelTotal }})
        </div>
      </q-inner-loading>
      <q-card-section class="row items-center q-mx-xs flex-shrink-0">
        <div class="text-h6">
          Add From Library
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section class="flex-grow-1 overflow-auto">
        <model-table
          :collection="libraryCollection"
          selection="multiple"
          :columns="columns"
          :cell-class="props => classesForRow(props.row)"
          :show-add="false"
          :show-edit="false"
          row-key="id"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        />
      </q-card-section>
      <q-card-actions class="row justify-end q-ma-sm flex-shrink-0">
        <q-btn
          :label="addLabel"
          color="primary"
          :disable="selected.length === 0"
          :loading="loading"
          @click="linkItems"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { Notify } from 'quasar'
import Model from 'src/models/model'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'AddFromLibraryDialog',
  components: {
    ModelTable: defineAsyncComponent(() => import('src/modules/admin/components/ModelTable'))
  },
  configuration: ['currentSite', 'currentCircuit'],
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    columns: {
      type: Array,
      required: false,
      default: null
    },
    collection: {
      type: Object,
      required: false,
      default: null
    },
    libraryCollection: {
      type: Object,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      selected: [],
      linkingModelName: '',
      linkingModelIndex: 0,
      linkingModelTotal: 0,
      loading: false
    }
  },
  computed: {
    addLabel () {
      return `Add ${this.selected.length === 1 ? this.libraryCollection.humanTypeName : this.libraryCollection.humanCollectionName} from the Library (${this.selected.length})`
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    classesForRow (libraryModel) {
      const alreadyInCollection = _.includes(_.map(this.collection.data, 'libraryParentId'), libraryModel.id)
      const alreadyAdded = alreadyInCollection || _.includes(_.values(libraryModel.libraryChildSiteIds), this.currentSite.id)

      if (alreadyAdded) {
        return ['tr-bg-grey-4', 'bg-grey-4']
      } else {
        return []
      }
    },
    async linkItems () {
      if (_.isEmpty(this.selected)) return

      const models = this.selected

      this.linkingModelName = ''
      this.linkingModelIndex = 0
      this.linkingModelTotal = models.length

      try {
        this.loading = true

        const allErrors = []
        // We cannot use await within _.each
        for (const model of models) {
          this.linkingModelName = model.name || model.displayName || model.title || model.description
          this.linkingModelIndex++
          const { errors: linkErrors } = await model.duplicateModelToSite(model.id, this.currentSite.id, true)
          allErrors.push(linkErrors)
        }

        this.linkingModelName = ''
        this.linkingModelIndex = 0
        this.linkingModelTotal = 0
        this.loading = false

        if (!_.isEmpty(_.flatten(allErrors))) {
          Notify.create({
            message: 'Error linking models to site',
            type: 'negative',
            position: 'top'
          })
        } else {
          this.shown = false
        }
      } finally {
        this.linkingModelName = ''
        this.linkingModelIndex = 0
        this.linkingModelTotal = 0
        this.loading = false

        this.libraryCollection.fetch(true)
        this.collection?.fetch(true)
        Model.configuration?.validate()
      }
    }
  }
}

</script>

<style lang="scss" scoped>
:deep(.tr-bg-grey-4) {
  background: #DDD;
}
</style>
